// "An Automated Task Burned $55 in 5 Days" — runaway-loop cost incident short.
// Cold Compute / Neon kit. ~143s @ 30fps. All claims grounded in EAKC-MVP code.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames (30fps); contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //         0:00–0:05  $55 in 5 days
  incident: { start: 150, duration: 540 }, //   0:05–0:23  dashboard said $1.80
  why: { start: 690, duration: 480 }, //        0:23–0:39  one mission looped forever
  rootcause: { start: 1170, duration: 540 }, // 0:39–0:57  Pause did nothing
  guards: { start: 1710, duration: 690 }, //    0:57–1:20  three guards
  code: { start: 2400, duration: 750 }, //      1:20–1:45  the cron-NULL guard SQL/TS
  meter: { start: 3150, duration: 540 }, //     1:45–2:03  meter must wrap the request
  outro: { start: 3690, duration: 360 }, //     2:03–2:15
} as const;

export const TOTAL_DURATION = 4050; // 135s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
